<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header  title-text-color border-bottom-schedulecard bg-blue">

        Day's Availability : {{TodayDate  | date: 'MMM dd, yyyy' }}
        <label *ngIf="EmpNonAvailabilityRequest">, Ref: {{EmpNonAvailabilityRequest.EmpNonAvailabilityCode}}</label>

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body padding-tb">


        <div class="row">
          <div class="col-md-12 background-2">
            <div class="card">             
              <div class="card-body background-2 padding-tb margin-left-zero">
                <div class="row">
                  <div class="col-md-12 padding-l-0px form-check">
                    <input type="radio"
                           [value]="true"
                           [(ngModel)]="IsAvailable" name="availability"
                           class="radio-width" />
                    <label class="availabeltext">  Available</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 padding-l-0px form-check">
                    <input type="radio"
                           [value]="false"
                           [(ngModel)]="IsAvailable" name="availability"
                           class="radio-width" /><label class="availabeltext">  Not Available</label>
                  </div>

                </div>
                <div *ngIf="!IsAvailable">
                  <label class="normal-small-text2 margin-left margin-left-reason">Reason</label>


                  <div class="col-md-12">
                    <CodeTypeValue CodeType="EMNAR" id="EmpNAReason"
                                   [(ngModel)]="EmpNonAvialabilityReason" SelectedValue="{{EmpNonAvialabilityReason}}"
                                   name="EmpNonAvialabilityReason" #NAReason="ngModel"></CodeTypeValue>

                  </div>
                  <div>
                    <label class="normal-small-text2 margin-left-reason ">Remarks</label>
                    <div class="col-md-12 margin-bottom-10px ">

                      <!--<input type="text" class="form-control" />-->
                      <textarea type="text" class="form-control" rows="4" id="NARemarks"
                                [(ngModel)]="NARemarks"
                                name="NARemarks"
                                placeholder="Reason for Non-Availability" maxlength="512"></textarea>


                    </div>

                  </div>
                </div>
              </div>
              <div class="card-footer border-top2 background-2">


                <button class="btn  actions-btn-prime2 font-size float-right button-Schedule" type="button"> Reset </button>
                <button (click)="SaveNonAvailability()"
                        class="btn btn-primary actions-btn-prime2 font-size float-right" type="button">
                  Save
                </button>

              </div>
            </div>

          </div>
          <div class="col-md-8" hidden>
            <div class="card">
              <div class="card-header wh-header title-text-color">
                Assignments <!--<span class="count thick-circle7">3</span>-->
              </div>
              <!--<div class="chatsd product-chart-wrapper ps chatsd2" data-ps-id="1254">
                <div class="card-body padding-tb">
                  <div class="card">


                    <div class="card-header ">
                      <label class="normal-small-text6">7a-7p</label>
                      <div class="thick-circle3 float-right"><i class="fas fa-check-circle"></i></div>
                    </div>
                    <div class="card-body  padding-tb">
                      <div class="card">
                        <div class="card-header wh-header padding-lr-0px">
                          <div class="row row-margin-zero">
                            <div class="col-md-7 col-xs-12 col-12 text-left padding-lr-0px">
                              <label class="normal-small-text2">

                                Centinella Hospital Center
                              </label>

                              <div>

                                <label class="normal-small-text">  California ,Alabama</label>
                              </div>
                            </div>

                            <div class="col-md-5 col-xs-12 col-12  text-right padding-lr-0px margin-left">
                              <label class="normal-small-text">
                                Aug-1-2018 To Aug-3-2018
                              </label>
                              <div>
                                <label class="normal-small-text"> 2 Days</label>
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="card-body padding-tb">
                          <div class="row">
                            <div class="col-md-4 col-xs-3 col-3 padding-left-18px">
                              <label class="normal-small-text ">
                                Pay Rate
                              </label>
                              <div>
                                <label class="text8">$55/hr</label>
                              </div>
                            </div>
                            <div class="col-md-4 col-xs-3 col-3 background padding-left-18px padding-lr-0px">
                              <label class="normal-small-text">
                                Duration
                              </label>
                              <div>
                                <label class="text8">2 Days</label>
                              </div>
                            </div>
                            <div class="col-md-4 col-xs-3 col-3  padding-left-18px">
                              <div>
                                <label class="normal-small-text">
                                  Total
                                </label>
                              </div>
                              <label class="text8">$950</label>
                            </div>

                          </div>
                          <div class="row">
                            <div class="col-md-12 col-xs-3 col-3  text-align-right margin-top">
                              <label class="normal-small-text padding-left-18px">

                              </label>
                              <div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>







                  </div>
                  <div class="card col-md-12  ">
                    <div class="card-header">
                      <label class="normal-small-text6">10p-4a</label>
                      <div class="thick-circle3 float-right"><i class="fas fa-times"></i></div>
                    </div>
                    <div class="card-body  padding-tb">
                      <div class="card">
                        <div class="card-header wh-header padding-lr-0px">
                          <div class="row row-margin-zero">
                            <div class="col-md-7 col-xs-12 col-12 text-left padding-lr-0px">
                              <label class="normal-small-text2">

                                Centinella Hospital Center
                              </label>

                              <div>

                                <label class="normal-small-text">  California ,Alabama</label>
                              </div>
                            </div>

                            <div class="col-md-5 col-xs-12 col-12  text-right padding-lr-0px margin-left">
                              <label class="normal-small-text">
                                Aug-1-2018 To Aug-3-2018
                              </label>
                              <div>
                                <label class="normal-small-text"> 2 Days</label>
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="card-body padding-tb">
                          <div class="row">
                            <div class="col-md-4 col-xs-3 col-3 padding-left-18px">
                              <label class="normal-small-text ">
                                Pay Rate
                              </label>
                              <div>
                                <label class="text8">$55/hr</label>
                              </div>
                            </div>
                            <div class="col-md-4 col-xs-3 col-3 background padding-left-18px padding-lr-0px">
                              <label class="normal-small-text">
                                Duration
                              </label>
                              <div>
                                <label class="text8">2 Days</label>
                              </div>
                            </div>
                            <div class="col-md-4 col-xs-3 col-3  padding-left-18px">
                              <div>
                                <label class="normal-small-text">
                                  Total
                                </label>
                              </div>
                              <label class="text8">$950</label>
                            </div>

                          </div>
                          <div class="row">
                            <div class="col-md-12 col-xs-3 col-3  text-align-right margin-top">
                              <label class="normal-small-text padding-left-18px">

                              </label>
                              <div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>







                  </div>
                  <div class="card col-md-12 ">
                    <div class="card-header">
                      <label class="normal-small-text6">10a-3p</label>
                      <div class="thick-circle3 float-right"><i class="fas fa-ellipsis-h"></i></div>
                    </div>
                    <div class="card-body  padding-tb">
                      <div class="card">
                        <div class="card-header wh-header padding-lr-0px">
                          <div class="row row-margin-zero">
                            <div class="col-md-7 col-xs-12 col-12 text-left padding-lr-0px">
                              <label class="normal-small-text2">

                                Centinella Hospital Center
                              </label>

                              <div>

                                <label class="normal-small-text">  California ,Alabama</label>
                              </div>
                            </div>

                            <div class="col-md-5 col-xs-12 col-12  text-right padding-lr-0px margin-left">
                              <label class="normal-small-text">
                                Aug-1-2018 To Aug-3-2018
                              </label>
                              <div>
                                <label class="normal-small-text"> 2 Days</label>
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="card-body padding-tb">
                          <div class="row">
                            <div class="col-md-4 col-xs-3 col-3 padding-left-18px">
                              <label class="normal-small-text ">
                                Pay Rate
                              </label>
                              <div>
                                <label class="text8">$55/hr</label>
                              </div>
                            </div>
                            <div class="col-md-4 col-xs-3 col-3 background padding-left-18px padding-lr-0px">
                              <label class="normal-small-text">
                                Duration
                              </label>
                              <div>
                                <label class="text8">2 Days</label>
                              </div>
                            </div>
                            <div class="col-md-4 col-xs-3 col-3  padding-left-18px">
                              <div>
                                <label class="normal-small-text">
                                  Total
                                </label>
                              </div>
                              <label class="text8">$950</label>
                            </div>

                          </div>
                          <div class="row">
                            <div class="col-md-12 col-xs-3 col-3  text-align-right margin-top">
                              <label class="normal-small-text padding-left-18px">

                              </label>
                              <div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>







                  </div>


                </div>
                </div>-->
              <div class="card-body padding-lrtp-0 margin-left-zero">
                <div class="table-component">
                  <div class="table-responsive">

                    <table class="table table-striped margin-lr-auto">
                      <thead >
                        <tr>
                          <th scope="col" class="table-header">Shift Time</th>
                          <th scope="col" class="table-header">Hospital Name</th>
                          <th scope="col" class="table-header">Pay Rate</th>
                          <th scope="col" class="table-header"></th>


                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>7a-7p </td>
                          <td>
                            <label class="normal-small-text2">

                              Centinella Hospital Center
                            </label>
                            <label class="normal-small-text">  California ,Alabama</label>

                          </td>
                          <td>$55/hr </td>
                          <td><div class="thick-circle3 float-right"><i class="fas fa-check-circle"></i></div> </td>



                        </tr>
                        <tr>
                          <td>10p-4a </td>
                          <td>
                            <label class="normal-small-text2">

                              Centinella Hospital Center
                            </label>
                            <label class="normal-small-text">  California ,Alabama</label>

                          </td>
                          <td>$55/hr </td>
                          <td><!--<div class="thick-circle3 float-right"><i class="fas fa-check-circle"></i></div>--> </td>



                        </tr>
                        <tr>
                          <td>10a-3p</td>
                          <td>
                            <label class="normal-small-text2">

                              Centinella Hospital Center
                            </label>
                            <label class="normal-small-text">  California ,Alabama</label>

                          </td>
                          <td>$55/hr </td>
                          <td><!--<div class="thick-circle3 float-right"><i class="fas fa-check-circle"></i></div>--> </td>



                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>


